import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../../DependencyHelper";
import Checkbox from "../../../../atoms/checkBox/Checkbox";
import { createMarkup } from "../../../../../utils/helperServices";
import formStyles from "./ConsentResultsForm.module.scss";

const ConsentResultsForm = ({
  formName,
  fieldValues,
  onChangeHandler,
  onResetHandler,
  formContent
}) => {
  const handleChange = event => {
    onChangeHandler(event, formName);
  };
  return (
    <CustomContainer className={`${formStyles["main-container"]}`}>
      <Form.Row className={`${formStyles["main-row"]}`}>
        {formContent.map((item, index) => {
            return(
            <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={`${formStyles["form-group"]}`}
            key={index}
          >
            <Form.Check
              custom
              name={"consentCheck"+index}
              label={<span dangerouslySetInnerHTML={createMarkup(item.description)}></span>}
              onChange={handleChange}
              className={formStyles["form-checkbox-label"]}
              id={item.id}
            />
          </Form.Group>
            )
        })}

      </Form.Row>
    </CustomContainer>
  );
};

ConsentResultsForm.propTypes = {
  formName: PropTypes.string,
  fieldValues: PropTypes.object,
  onChangeHandler: PropTypes.func,
  onResetHandler: PropTypes.func,
};

ConsentResultsForm.defaultProps = {
  fieldValues: {}
};

export default ConsentResultsForm;
